import visAssembledImage from './image/vis-assembled.png'
import customCdrImage from './image/custom-cdr.png'
import designRating24 from '../../assets/img/24.png'
import designRating25 from '../../assets/img/25.png'
import designRating26 from '../../assets/img/26.png'
import designRating28 from '../../assets/img/28.png'
import designRating from '../../assets/img/23.png'
import designRating29 from '../../assets/img/29.png'
import designRating36 from './image/36.png'
import designRating27 from './image/49.png'
import designRating30 from './image/30.png'
import designRating32 from './image/32.png'
import designRating31 from './image/31.png'
import designRating33 from './image/33.png'
import designRating34 from './image/34.png'
import designRating35 from './image/35.png'
import designRating37 from './image/37.png'
import designRating38 from './image/38.png'
import designRating39 from './image/39.png'
import designRating43 from './image/43.png'
import designRating45 from './image/45.png'
import designRating46 from './image/46.png'
import designRating47 from './image/47.png'

import des from './image/1.jpg'
import des2 from './image/2.jpg'
import des3 from './image/3.jpg'
import des4 from './image/4.jpg'
import des5 from './image/5.jpg'

import designRatingf57 from './image/f57.png'
import designRatingf58 from './image/f58.png'
import designRatingf46 from './image/f46.png'
import designRatingf51 from './image/f51.png'

// моковые данные каталога, пока без бэка — основа взята из CARD_DESIGNS главной страницы

export type CatalogCategory = 'pvh' | 'paper' | 'special'

export interface CatalogColor {
    id: string;
    label: string;
    swatch: string;
    image: string;
}

export interface CatalogDesign {
    id: string;
    title: string;
    description: string;
    image: string;
    category: CatalogCategory;
    // цена в рублях; без значения — по запросу
    price?: number;
    badge?: string;
    colors?: CatalogColor[];
    customizable?: boolean;
    // Готовая объёмная модель вместо стандартной плоской визитки.
    modelUrl?: string;
}

export interface CatalogCategoryItem {
    id: CatalogCategory | 'all';
    label: string;
    // пояснение под фильтрами, когда категория выбрана
    note?: string;
}

// бумажные визитки печатаются без NFC-модуля — работают только по QR-коду
export const NO_NFC_CATEGORIES: CatalogCategory[] = ['paper']

// материал для текста заявки; у особых визиток материал обсуждается отдельно
export const CATEGORY_MATERIALS: Partial<Record<CatalogCategory, string>> = {
    pvh: 'пластиковая',
    paper: 'бумажная',
}

export const CATALOG_CATEGORIES: CatalogCategoryItem[] = [
    {id: 'all', label: 'Все'},
    {id: 'pvh', label: 'Пластик'},
    {id: 'paper', label: 'Бумага', note: 'Все бумажные визитки - без NFC-модуля, работают только по QR-коду'},
    {id: 'special', label: 'Особые'},
]

export const CATALOG_DESIGNS: CatalogDesign[] = [
    // {
    //     id: 'custom-cdr',
    //     title: 'Свой цвет',
    //     description: 'Выберите сочетание или настройте цвет фона, узора и деталей на свой вкус',
    //     image: customCdrImage,
    //     category: 'pvh',
    //     badge: 'Ваши цвета',
    //     customizable: true,
    // },
    {
        id: 'rating',
        title: 'Классический',
        description: 'Наш классический дизайн, подойдет для любых целей',
        image: designRating24,
        category: 'pvh',
        price: 800,
        badge: 'Хит',
        colors: [
            {id: 'black', label: 'Чёрный', swatch: '#161616', image: designRating24},
            {id: 'white', label: 'Белый', swatch: '#FFFFFF', image: designRating25},
            {id: 'green', label: 'Зелёный', swatch: '#CDFF46', image: designRating26},
            {id: 'mega-green', label: 'Очень зелёный', swatch: '#A8E10C', image: designRating36},
            // {id: 'mega-green', label: 'Зеленый с вашим фоном', swatch: '#A8E10C', image: designRating57},
            // {id: 'mega-green', label: 'Черный с вашим фоном', swatch: '#161616', image: designRating58},
        ],
    },
    {
        id: 'girl',
        title: 'VG',
        description: 'Теплый белый цвет и рисунок в аниме стиле',
        image: designRating43,
        category: 'pvh',
        price: 800,
        colors: [
            {id: 'white', label: 'Декоративный белый', swatch: '#F4F4F2', image: designRating43},
        ],
    },
    {
        id: 'dscantouch',
        title: 'Dont scan or touch',
        description: 'Сканирование QR-кода или NFC метки запрещено',
        image: designRating38,
        category: 'pvh',
        price: 800,
        colors: [
            {id: 'black', label: 'Чёрный', swatch: '#161616', image: designRating38},
            {id: 'white', label: 'Белый', swatch: '#FFFFFF', image: designRating39},
        ],
    },
    {
        id: 'vis-stand',
        title: 'Стенд',
        description: 'Настольная карточка с QR-кодом и NFC модулем на подставке',
        image: visAssembledImage,
        modelUrl: `${process.env.PUBLIC_URL}/models/vis-assembled.glb`,
        category: 'special',
        price: 800,
    },
    {
        id: 'rave',
        title: 'Поток',
        description: 'Минималистичный дизайн соединяющий в себе все основные цвета',
        image: designRating27,
        category: 'pvh',
        price: 800,
        colors: [
            {id: 'black', label: 'Чёрный', swatch: '#161616', image: designRating27},
        ],
    },
    // {
    //     id: 'vizitka',
    //     title: 'В изи тка',
    //     description: 'Простой ребус для клиентов',
    //     image: designRating34,
    //     category: 'paper',
    //     price: 15,
    //     colors: [
    //         {id: 'black', label: 'Чёрный', swatch: '#161616', image: designRating34},
    //     ],
    // },
    // {
    //     id: 'chto',
    //     title: '?',
    //     description: 'Мы не знаем что это',
    //     image: designRating35,
    //     category: 'paper',
    //     price: 15,
    //     colors: [
    //         {id: 'black', label: 'Чёрный', swatch: '#161616', image: designRating35},
    //     ],
    // },
    {
        id: 'cute',
        title: 'Минимализм',
        description: 'Универсальный дизайн, оставьте только самое важное',
        image: designRating,
        category: 'pvh',
        price: 800,
        colors: [
            {id: 'black', label: 'Чёрный', swatch: '#161616', image: designRating},
            {id: 'white', label: 'Белый', swatch: '#FFFFFF', image: designRating29},
            {id: 'black', label: 'Ультра чёрный', swatch: '#000000', image: designRating45},
            {id: 'white', label: 'Ультра белый', swatch: '#FFFFFF', image: designRating46},
        ],
    },
    {
        id: 'сaplya',
        title: 'Волна',
        description: 'Минималистичный дизайн соединяющий в себе все основные цвета',
        image: designRating47,
        category: 'pvh',
        price: 800,
        colors: [
            {id: 'black', label: 'Чёрный', swatch: '#161616', image: designRating47},
        ],
    },
    {
        id: 'points',
        title: 'Раскраска',
        description: 'Минималистичный пиксельный пейзаж',
        image: designRatingf46,
        category: 'pvh',
        price: 800,
        colors: [
            {id: 'black', label: 'Чёрный', swatch: '#161616', image: designRatingf46},
        ],
    },
    {
        id: 'visitka',
        title: 'Визитка',
        description: 'Точно визитка',
        image: designRating30,
        category: 'paper',
        price: 15,
        colors: [
            {id: 'black', label: 'Чёрный', swatch: '#161616', image: designRating30},
            {id: 'white', label: 'Белый', swatch: '#FFFFFF', image: designRating32},
        ],
    },
    {
        id: 'nevisitka',
        title: 'Не визитка',
        description: 'Не точно визитка',
        image: designRating31,
        category: 'paper',
        price: 15,
        colors: [
            {id: 'black', label: 'Чёрный', swatch: '#161616', image: designRating31},
            {id: 'white', label: 'Белый', swatch: '#FFFFFF', image: designRating33},
        ],
    },
    {
        id: 'trait',
        title: 'Отзывы',
        description: 'Специальный дизайн для сбора оценок и отзывов',
        image: des,
        category: 'pvh',
        price: 800,
        colors: [
            {id: 'type1', label: 'Вариант 1', swatch: '#68bb59', image: des},
            {id: 'type2', label: 'Вариант 2', swatch: '#43ae82', image: des2},
            {id: 'type3', label: 'Вариант 3', swatch: '#b27945', image: des3},
            {id: 'type4', label: 'Вариант 4', swatch: '#a23f93', image: des4},
            {id: 'type5', label: 'Вариант 5', swatch: '#5b5fb8', image: des5},
            // {id: 'mega-green', label: 'Зеленый с вашим фоном', swatch: '#A8E10C', image: designRating57},
            // {id: 'mega-green', label: 'Черный с вашим фоном', swatch: '#161616', image: designRating58},
        ],
    },
    {
        id: 'uzor',
        title: 'Орнамент',
        description: 'Узор обтекающий ваш QR-код',
        image: designRatingf51,
        category: 'pvh',
        price: 800,
        colors: [
            {id: 'black', label: 'Чёрный', swatch: '#161616', image: designRatingf51},
        ],
    },
    {
        id: 'dscan',
        title: 'Dont scan',
        description: 'Сканирование запрещено',
        image: designRating37,
        category: 'paper',
        price: 15,
        colors: [
            {id: 'black', label: 'Чёрный', swatch: '#161616', image: designRating37},
        ],
    },
    // {
    //     id: 'social',
    //     title: 'Мы в соц сетях',
    //     description: 'Собирает подписчиков во все соцсети магазина в один клик',
    //     image: designSocial,
    //     category: 'business',
    //     price: 990,
    // },
    // {
    //     id: 'limited',
    //     title: 'Лимитированная',
    //     description: 'Нумерованная серия с необычным дизайном для коллекционеров',
    //     image: designLimited,
    //     category: 'special',
    //     price: 1490,
    //     badge: 'Мало',
    // },
    // {
    //     id: 'soft',
    //     title: 'Милый',
    //     description: 'Мягкий и дружелюбный дизайн для блогов и личных страниц',
    //     image: designCute,
    //     category: 'personal',
    //     price: 890,
    // },
    {
        id: 'custom',
        title: 'Кастом',
        description: 'Пришлите ваш дизайн или закажите его у нас',
        image: designRating28,
        category: 'special',
    },
]
